/* eslint-disable react-hooks/exhaustive-deps */
import type { ReactElement } from 'react';
import { Redirect } from 'react-router-dom';
import { useAuthentication } from '@/hooks';

type RequireAuthProps = {
  children: ReactElement;
};

export default function RequireAuth({
  children,
}: RequireAuthProps): ReactElement {
  const { authenticated } = useAuthentication();

  return authenticated ? children : <Redirect to="/" exact />;
}
